<template>
    <div class="content-box">
      <Title />
      <div class="title-right">
            <!-- <img
              src="https://www.100ec.cn/Public/home/images/dd.gif"
            /> -->
        </div>
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
      >
        <el-menu-item
          :index="String(index + 1)"
          v-for="(i, index) of dataNav"
          :key="index"
          @click="handleSelect(index)"
        >
          {{ i.label }}</el-menu-item
        >
      </el-menu>
  
      <div class="mobile-select">
        <el-select v-model="name" @change="handleSelect2">
          <el-option
            v-for="item in dataNav"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
  
      <div>
        <div v-loading="$store.state.loading">
          <div class="text">
            <a
              v-for="(i, index) in $store.state.text"
              :key="index"
              :href="'/detail--' + i.id + '.html'"
              target="_blank"
            >
              <div class="img">
                <el-image
                  v-if="index <= 40"
                  :src="require('@/assets/' + index + '.jpg')"
                  lazy
                ></el-image>
                <el-image
                  v-else
                  :src="require('@/assets/' + (index % 40) + '.jpg')"
                  lazy
                ></el-image>
              </div>
              <div class="con">
                <span v-html="i.title"></span>
                <p>{{ i.post_date.split(/T|Z/).join(" ") }}</p>
              </div>
            </a>
          </div>
        </div>
  
        <div v-if="$store.state.more" class="more">
          <el-button type="primary" plain @click="handleSelect3">
            查看更多</el-button
          >
        </div>
      </div>
    </div>
  </template>

<script>
export default {
    name: "broadCast",
    data() {
        return {
            activeIndex: '1',
            name: '滚动播报',
            iflist: "数字健康",
            list: "9",
            dataNav: [
                {
                    value: '数字健康',
                    label: '滚动播报'
                },
                {
                    value: '健康',
                    label: '互联网健康'
                },
                {
                    value: '医疗',
                    label: '互联网医疗'
                },
                {
                    value: 'AI 医疗',
                    label: 'AI医疗'
                },
                {
                    value: '医院',
                    label: '互联网医院'
                },
                {
                    value: '医药',
                    label: '医药电商'
                },
                {
                    value: '问诊',
                    label: '在线问诊'
                },
                {
                    value: '医美',
                    label: '医美'
                },
                {
                    value: '运动 健身',
                    label: '运动健身'
                },
                {
                    value: '疫苗',
                    label: '疫苗'
                },
                {
                    value: '心理',
                    label: '心理'
                },
                {
                    value: '体检',
                    label: '体检'
                },
                {
                    value: '医保',
                    label: '医保'
                },
                {
                    value: '中医',
                    label: '中医'
                },
                {
                    value: '中药',
                    label: '中药'
                },
            ],
            params: {
                json: 0,
                filter: [
                    "【",
                    "研报",
                    "分析",
                    "（PPT）",
                    "（全文）",
                ]
            }
        }
    },
    created() {
    this.$store.commit("textparams", this.params);
    // this.$store.commit("changeKeys", this.dataNav[0].value);
    if ((this.dataNav.value = "数字健康")) {
      this.$store.commit("changeKeys", this.list);
      this.$store.dispatch("getText2");
    } else {
      this.$store.dispatch("getText");
    }
    this.$store.state.allNav.forEach((item) => {
      item.child.forEach((j) => {
        if (this.$route.path.indexOf(j.url) != -1) {
          this.title = j.name;
          if (this.title == "首页") {
            this.title = "滚动播报";
          }

          if (item.more != undefined) {
            this.more = item.more;
          } else if (j.more != undefined) {
            this.more = j.more;
          }
        }
      })
    });
    handleSelect3();

  },
  methods: {
    handleSelect(index) {
      this.iflist =  this.dataNav[index].value
      if (this.dataNav[index].value == "数字健康") {
        this.$store.commit("changeKeys", this.list);
        this.$store.dispatch("getText2");
      } else {
        this.$store.commit("changeKeys", this.dataNav[index].value);
        this.$store.dispatch("getText");
      }
    },
    handleSelect2(value) {
      this.$store.commit("changeKeys", value);
      this.$store.dispatch("getText");
    },
    handleSelect3(){
      if (this.iflist == '数字健康') {
        this.$store.dispatch("getText2");
      } else {
        this.$store.dispatch("getText");
      }
    },
  },
}
</script>
<style scoped>

.title{
  position: relative;
}
.title-right{
    position: absolute;
    left: 195px;
    top: 65px;
}
.title-right img{
  width: 580px;
  height: 70px;
}
@media (max-width: 1100px) {
  .title-right{
    position: static;
    margin: 10px 0;
}
.title-right img{
  width: 100%;
  height: 50px;
}
}
</style>